module.exports = __webpack_public_path__ + "static/2_1_search-2_ES-d83b3849701873055c3eaf779f8dea66.svg";